"use client";

import type * as React from "react";
import { cn } from "@/lib/utils";

interface YellowBoxProps {
  label: string;
  value: React.ReactNode;
  variant?: "metric" | "highlight";
  className?: string;
}

export const YellowBox: React.FC<YellowBoxProps> = ({
  label,
  value,
  variant = "metric",
  className,
}) => {
  return (
    <div
      className={cn(
        "flex flex-col font-bold items-center justify-center text-center rounded-lg space-y-3 py-3 px-2 w-full bg-accent-secondary text-text-button-label",
        variant === "highlight" && "py-4",
        className,
      )}
    >
      <p className="text-xs">{label}</p>
      <div>{value}</div>
    </div>
  );
};
